// extracted by mini-css-extract-plugin
export var hideEditor = "_mt-2";
export var infoIcon = "_mt-3";
export var label = "_mt-1";
export var labelContainer = "_mt-0";
export var readonlyText = "_mt-4";